import { COUPON_STATUS, PAYMENT_COUPON_TYPE } from "app/constants";
import AmountContainer from "app/pages/.shared/AmountContainer";
import AmountSign from "app/pages/.shared/AmountSign/AmountSign";
import MoreDetails from "app/pages/.shared/MoreDetails";
import { IconCredit } from "app/pages/.shared/static/icons";
import MyCouponCredit from "app/pages/Account/MyCoupons/MyCouponCredit/MyCouponCredit";
import { sendTagOnMoreDetailCreditClick } from "app/utils/analytics";
import PropTypes from "prop-types";
import { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import "./CreditRadio.scss";
import RadioFormik from "app/pages/.shared/form/RadioFormik";

const CreditRadio = ({ onChange = () => {}, value, usableCredits = [], couponType }) => {
	const handleOnClick = useCallback(() => {
		sendTagOnMoreDetailCreditClick();
	}, []);

	const checked = {
		value: couponType === PAYMENT_COUPON_TYPE.CREDIT,
		shouldCheckTheValue: true,
	};

	return (
		<RadioFormik
			showIcon={true}
			name="credit-radio"
			id="credit-radio"
			value={PAYMENT_COUPON_TYPE.CREDIT}
			checked={checked}
			toggle={() => {
				onChange(PAYMENT_COUPON_TYPE.CREDIT);
			}}
			data-testid={`coupon-credit-input`}
			body={
				<div className="credit-radio__body">
					<MoreDetails
						headerPosition={"bottom"}
						expandedLabel={<FormattedMessage id="product.page.less.details" />}
						collapsedLabel={<FormattedMessage id="product.page.more.details" />}
						onChange={handleOnClick}
					>
						{usableCredits.map(usableCredit => {
							return (
								<div className="credit-radio__coupon-item" key={usableCredit.title}>
									<MyCouponCredit
										{...usableCredit}
										status={COUPON_STATUS.USING}
									/>
								</div>
							);
						})}
					</MoreDetails>
				</div>
			}
		>
			<div className="credit-radio__content">
				<div className="credit-radio__name">
					<div className="credit-radio__icon" data-testid="credit-radio-icon">
						<IconCredit />
					</div>
					<FormattedMessage id="payment.coupons.input.credits.label" />
				</div>
				<div className="credit-radio__amount">
					<AmountContainer amount={value} prefix={<AmountSign sign="-" />} />
				</div>
			</div>
		</RadioFormik>
	);
};

CreditRadio.propTypes = {
	onChange: PropTypes.func,
	value: PropTypes.number,
	usableCredits: PropTypes.array,
	couponType: PropTypes.string,
};

export default CreditRadio;
